const $88e027e6c58bc5a9$export$57ca7e07b341709d = ()=>()=>"";


const $be1409ce3664cb58$export$c84356afd4299847 = (inputStr = (0, $88e027e6c58bc5a9$export$57ca7e07b341709d)())=>(nextInputStr = (0, $88e027e6c58bc5a9$export$57ca7e07b341709d)())=>{
        let str1 = inputStr;
        let str2 = nextInputStr;
        while(typeof str1 === "function")str1 = str1();
        while(typeof str2 === "function")str2 = str2();
        return `${str1}${str2}`;
    };


const $01b8e242892745eb$var$CONSTANT = {
    CONFIG: {
        dividerType: " ",
        dividerRepeat: 5,
        dividerBefore: "\n",
        dividerAfter: "\n",
        tabType: " ",
        tabRepeat: 4,
        instructionSpacing: "\n"
    }
};
function $01b8e242892745eb$export$44487a86467333c3() {
    return $01b8e242892745eb$var$CONSTANT.CONFIG;
}
function $01b8e242892745eb$export$940a7873bb071df8(newConfig) {
    $01b8e242892745eb$var$CONSTANT.CONFIG = {
        ...$01b8e242892745eb$var$CONSTANT.CONFIG,
        ...newConfig
    };
}


const $a83f9b90828131d5$export$2e0a83ec2e27ecbb = ()=>{
    const config = (0, $01b8e242892745eb$export$44487a86467333c3)();
    const separator = config.dividerType;
    const repeatCount = config.dividerRepeat;
    return (0, $be1409ce3664cb58$export$c84356afd4299847)(`${config.dividerBefore}${separator.repeat(repeatCount)}${config.dividerAfter}`);
};






const $398e68d9d81d8e02$export$b2539bed5023c21c = (prompt)=>(input = (0, $88e027e6c58bc5a9$export$57ca7e07b341709d)())=>{
        const config = (0, $01b8e242892745eb$export$44487a86467333c3)();
        const TAB_TEXT = config.tabType.repeat(config.tabRepeat);
        let text = (0, $be1409ce3664cb58$export$c84356afd4299847)(prompt)(input);
        text = TAB_TEXT + text;
        text = text.replaceAll("\n", `\n${TAB_TEXT}`);
        return text;
    };



const $28c395d30832aadc$export$f672e0b6f7222cd7 = (...strFns)=>{
    return (input)=>{
        const safeInput = (0, $be1409ce3664cb58$export$c84356afd4299847)()(input);
        return strFns.reduceRight((result, next)=>{
            return (0, $be1409ce3664cb58$export$c84356afd4299847)(next)(result);
        }, safeInput);
    };
};




const $31b934ee2645b4aa$export$f361d4ae234b90f4 = (instructionTitle, instructionText)=>{
    return (0, $28c395d30832aadc$export$f672e0b6f7222cd7)((0, $be1409ce3664cb58$export$c84356afd4299847)(instructionTitle), (0, $be1409ce3664cb58$export$c84356afd4299847)(`:${(0, $01b8e242892745eb$export$44487a86467333c3)().instructionSpacing}`), (0, $398e68d9d81d8e02$export$b2539bed5023c21c)((0, $be1409ce3664cb58$export$c84356afd4299847)(instructionText)));
};


function $b36d5c053b84c5f9$export$93514d28bd18d75a(dataStructureSample) {
    return (0, $31b934ee2645b4aa$export$f361d4ae234b90f4)(`Answer should be in a valid JSON, use the following structure`, `ResponseJSON: ${JSON.stringify(dataStructureSample)}`);
}







const $424c3997ee9230e7$export$6e2c8f0811a474ce = (instructionTitle, ...content)=>{
    let instructionText;
    switch(content.length){
        case 0:
            instructionText = (0, $be1409ce3664cb58$export$c84356afd4299847)("");
            break;
        case 1:
            instructionText = content[0];
            break;
        default:
            {
                // (content.length > 1)
                const dividedContent = [];
                content.forEach((cont)=>{
                    dividedContent.push(cont);
                    dividedContent.push((0, $a83f9b90828131d5$export$2e0a83ec2e27ecbb)());
                });
                dividedContent.pop();
                instructionText = (0, $28c395d30832aadc$export$f672e0b6f7222cd7)(...dividedContent);
                break;
            }
    }
    return (0, $28c395d30832aadc$export$f672e0b6f7222cd7)((0, $31b934ee2645b4aa$export$f361d4ae234b90f4)(instructionTitle, instructionText), (0, $a83f9b90828131d5$export$2e0a83ec2e27ecbb)());
};





function $6a125118fa5e689b$export$e1dae5660003ffa7(instruction) {
    return (0, $424c3997ee9230e7$export$6e2c8f0811a474ce)((0, $be1409ce3664cb58$export$c84356afd4299847)("System"), instruction); // Instruction(Statement("System"), );
}









export {$a83f9b90828131d5$export$2e0a83ec2e27ecbb as Divider, $b36d5c053b84c5f9$export$93514d28bd18d75a as Format, $31b934ee2645b4aa$export$f361d4ae234b90f4 as Instruction, $424c3997ee9230e7$export$6e2c8f0811a474ce as Section, $be1409ce3664cb58$export$c84356afd4299847 as Statement, $88e027e6c58bc5a9$export$57ca7e07b341709d as None, $6a125118fa5e689b$export$e1dae5660003ffa7 as System, $398e68d9d81d8e02$export$b2539bed5023c21c as Tabs, $28c395d30832aadc$export$f672e0b6f7222cd7 as compose, $01b8e242892745eb$export$44487a86467333c3 as getConfig, $01b8e242892745eb$export$940a7873bb071df8 as setConfig};
//# sourceMappingURL=module.js.map
